import { useEffect } from 'react';
import './App.css';

const miyabiHome = `${process.env.PUBLIC_URL || ''}/miyabi/index/index.html`;

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;
    if (window.location.pathname === '/' || window.location.pathname === '') {
      window.location.replace(miyabiHome);
    }
  }, []);

  if (process.env.NODE_ENV === 'production') {
    return (
      <div className="app-loading" role="status" aria-live="polite">
        <p>Opening Miyabi Kitchin…</p>
      </div>
    );
  }

  return (
    <div className="app-dev-frame">
      <p className="app-dev-banner">
        Development preview — production visitors are redirected to the static site at{' '}
        <code>/miyabi/index/index.html</code> (see <code>public/_redirects</code>).
      </p>
      <iframe title="Miyabi Kitchin" src={miyabiHome} className="app-site-iframe" />
    </div>
  );
}

export default App;
